import Vue from 'vue'
import Vuex from 'vuex'
import pathify from './pathify'
import actions from './actions'
import getters from './getters'
import ProgressBarModule from './modules/progress-bar/index'
import DataModule from './modules/data/index'

import LicensePeriodsModule from './modules/license-periods/index'
import LicensesModule from './modules/licenses/index'
import MetaDataFieldsModule from './modules/meta-data-fields/index'
import MetaDataCategoriesModule from './modules/meta-data-categories/index'
import ProductTypes from './modules/product-types/index'
import ProductsModule from './modules/products/index'
import PublishersModule from './modules/publishers/index'
import StakeholdersModule from './modules/stakeholders/index'
import SubscriptionsModule from './modules/subscriptions/index'
import TitleListsModule from './modules/title-lists/index'
import VendorsModule from './modules/vendors/index'
import WidgetsModule from './modules/widgets/index'
import ContactsModule from './modules/contacts'
import mutations from './mutations'
import RequestsModule from './modules/requests'
import EntityLabels from './modules/entity-labels'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV === 'development',
  plugins: [pathify.plugin],
  state: {
    accessToken: null,
    user: null,
    tenant: null,
    settings: {
      options: {
        featuredCurrencies: ['USD', 'EUR', 'GBP', 'CHF'],
        currencies: [],
        countries: [],
        users: []
      }
    },
    settingsFetched: false,
    loader: false,
    globalLoader: false,
    globalDialogVisible: {},
    globalDialogContent: {},
    emailPreferences: [],
    requestCancellationToken: null
  },
  actions,
  getters,
  mutations,
  modules: {
    progressBar: {
      ...ProgressBarModule
    },
    subscriptions: {
      ...SubscriptionsModule
    },
    products: {
      ...ProductsModule
    },
    licensePeriods: {
      ...LicensePeriodsModule
    },
    publishers: {
      ...PublishersModule
    },
    vendors: {
      ...VendorsModule
    },
    titleLists: {
      ...TitleListsModule
    },
    productTypes: {
      ...ProductTypes
    },
    stakeholders: {
      ...StakeholdersModule
    },
    data: {
      ...DataModule
    },
    licenses: {
      ...LicensesModule
    },
    metaDataCategories: {
      ...MetaDataCategoriesModule
    },
    metaDataFields: {
      ...MetaDataFieldsModule
    },
    widgets: {
      ...WidgetsModule
    },
    contacts: {
      ...ContactsModule
    },
    requests: {
      ...RequestsModule
    },
    'entity-labels': EntityLabels
  }
})
